module.exports = __webpack_public_path__ + "img/10.ca4748a1.png";